import { Checkbox, Label } from '@fluentui/react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import React, { Component, Fragment } from 'react';
import { DataTicket } from '../../data/DataTicket';
import { Immocom } from '../../specifique/immocom';
import { EUIDetailsList } from '../EUI/EUIDetailsList';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { FicheTicketHistorique } from '../Fiche/FicheTicketHistorique';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';

export class DetailsListHistorique extends Component {

    static defaultProps = {
        idTicket: undefined,
    };

    static defaultState = {
        itemActif: {},
        items: [],
        afficherDialogSuppressionTicketHistorique: false,
        afficherPanelTicketHistorique: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...DetailsListHistorique.defaultState };
        this._columns = this._getColumns();
        this._filtres = this._getFiltres();
        this._isSortedDescending = false;
        this._sortedColumn = "creerLe";
    };

    _appliquerFiltres = (filtres) => {
        this._filtres = { ...this._filtres, ...filtres };
        this._togglePanel("Filtres", false, null, this._chargementDonnees)();
    };

    _chargementDonnees = () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Chargement des historiques en cours"
        });

        const { idTicket } = this.props;
        const tri = `${this._sortedColumn} ${this._isSortedDescending ? "DESC" : "ASC"}`;

        DataTicket._chargementDesHistoriques(idTicket, tri, this._filtres).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null) {
                const historiques = responseFetch.reponseAPIobjet || [];
                const state = { items: historiques };
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, state);
            }
            else {
                const state = { items: [] };
                Immocom.onTraitementErreurAvecState(this, state, retourVerif, responseFetch);
            }
        });
    };

    _getColumns = () => {
        return [{
            key: "description",
            name: "Description",
        }, {
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            key: "creerLe",
            name: "Créé le",
        }, {
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            key: "creerPar",
            minWidth: 70,
            maxWidth: 100,
            name: "Créé par",
        }, {
            className: "ms-hiddenMdDown",
            headerClassName: "ms-hiddenMdDown",
            key: "etat",
            minWidth: 100,
            maxWidth: 240,
            name: "Etat",
        }, {
            key: "edit",
            isIconOnly: true,
            onRender: (item) => <IconButton
                ariaLabel="Modifier l'historique"
                iconProps={{ iconName: "Edit" }}
                onClick={this._togglePanel("TicketHistorique", true, item)}
                title="Modifier l'historique"
            />
        }, {
            key: "delete",
            isIconOnly: true,
            onRender: (item) => <IconButton
                ariaLabel="Supprimer l'historique"
                iconProps={{ iconName: "Delete" }}
                onClick={this._toggleDialog("SuppressionTicketHistorique", true, item)}
                title="Supprimer l'historique"
            />
        }];
    };

    _getFiltres = () => {
        return { ...PanelFiltres.defaultState };
    };

    _getItems = () => {
        return [{
            key: "new",
            name: "Nouvel historique",
            iconProps: { iconName: "Add" },
            onClick: this._togglePanel("TicketHistorique", true)
        }];
    };

    _onColumnHeaderClick = (sortedColumn, isSortedDescending) => {
        this._sortedColumn = sortedColumn;
        this._isSortedDescending = isSortedDescending;
        this._chargementDonnees();
    };

    _supprimerTicketHistorique = (idTicketHistorique) => () => {

        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: "Suppression de l'historique en cours"
        });

        DataTicket._onSuppressionTicketHistorique(idTicketHistorique).then(responseFetch => {
            const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
            if (retourVerif === null)
                Immocom.onReinitStateValeurParDefautEtExecutionDuSetStateEtExecutionCallBack(this, {}, this._chargementDonnees);
            else Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
        });

    };

    _toggleDialog = (nomDialog, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherDialog${nomDialog}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    _togglePanel = (nomPanel, isOpen, item, callback) => () => {
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                itemActif: item || {},
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount = () => {
        this._chargementDonnees();
    };

    render = () => {

        const { idTicket } = this.props;
        const {
            afficherDialogSuppressionTicketHistorique, afficherPanelFiltres, afficherPanelTicketHistorique,
            itemActif, items
        } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <MessageBars
                errorMessage={this.state.errorMessage}
                infoMessage={this.state.messageMessageBarFiltres}
                warningMessage={this.state.warningMessage}
                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
            />

            <EUIDetailsList
                columns={this._columns}
                getKey={item => item.idTicketHistorique}
                isSortedDescending={this._isSortedDescending}
                items={items}
                menuItems={this._getItems()}
                onColumnHeaderClick={this._onColumnHeaderClick}
                onFilterButtonClick={this._togglePanel("Filtres", true)}
                selectionMode={SelectionMode.none}
                sortedColumn={this._sortedColumn}
                wrapInScrollablePane={false}
            />

            <FicheTicketHistorique
                idTicket={idTicket}
                idTicketHistorique={itemActif.idTicketHistorique}
                isOpen={afficherPanelTicketHistorique}
                onDismiss={this._togglePanel("TicketHistorique", false)}
                onSave={this._togglePanel("TicketHistorique", false, {}, this._chargementDonnees)}
            />

            <PanelFiltres
                filtres={this._filtres}
                isOpen={afficherPanelFiltres}
                onDismiss={this._togglePanel("Filtres", false)}
                onValidate={this._appliquerFiltres}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._toggleDialog("SuppressionTicketHistorique", false, {}, this._supprimerTicketHistorique(itemActif.idTicketHistorique))} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionTicketHistorique", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionTicketHistorique}
                onDismiss={this._toggleDialog("SuppressionTicketHistorique", false)}
                titre="Suppression d'un historique"
            >
                Vous êtes en train de supprimer cet historique, voulez-vous continuer ?
            </EUIDialog>

        </Fragment>;

    };

};

class PanelFiltres extends Component {

    static defaultProps = {
        filtres: {},
        isOpen: false,
        /* --- */
        onDismiss: () => null,
        onValidate: () => null,
    };

    static defaultState = {
        afficherCommentaires: true,
        afficherLogs: false,
    };

    constructor(props) {
        super(props);
        this.state = this._getFiltresParDefaut();
    };

    _appliquerFiltres = () => {
        const filtres = { ...this.state };
        this.props.onValidate(filtres);
    };

    _getFiltresParDefaut = () => {
        const filtres = { ...PanelFiltres.defaultState };
        return filtres;
    };

    _reinitialiserFiltres = () => {
        this.setState(this._getFiltresParDefaut());
    };

    _onOpen = () => {
        this.setState({ ...this.props.filtres });
    };

    componentDidMount = () => {
        this._appliquerFiltres();
    };

    render = () => {

        const { isOpen, onDismiss } = this.props;
        const { afficherCommentaires, afficherLogs } = this.state;

        return <EUIPanel
            headerText="Filtres"
            isOpen={isOpen}
            onDismiss={onDismiss}
            onOpen={this._onOpen}
            onResetFilters={this._reinitialiserFiltres}
            onValidate={this._appliquerFiltres}
        >

            <Label>Afficher</Label>

            <Checkbox
                label="Commentaires"
                checked={afficherCommentaires}
                onChange={(e, isChecked) => this.setState({ afficherCommentaires: isChecked })}
            />

            <Checkbox
                label="Logs"
                checked={afficherLogs}
                onChange={(e, isChecked) => this.setState({ afficherLogs: isChecked })}
            />

        </EUIPanel>;

    };

};